<template>
  <div :class="['card', { 'card--link': isLink }]" :style="{ '--card-color': color }">
    <div class="card__wrap" @click="onCardClick">
      <component
        :is="isLink ? 'RouterLink' : 'div'"
        :to="isLink ? linkTo : {}"
        :data-test-created-at="entity.createdAt"
        class="card__link"
        draggable="false"
      >
        <div class="card__top">
          <slot name="top" />
        </div>

        <div class="card__bottom">
          <slot name="bottom" />
        </div>
      </component>

      <div class="card__settings">
        <slot name="settings" />
      </div>
    </div>

    <transition name="modal-transition">
      <slot name="modals" />
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { isEmpty } from 'ramda';

export default defineComponent({
  name: 'Card',
  emits: { 'card-click': null },

  props: {
    color: {
      type: String,
      required: false,
      default: undefined,
    },
    entity: {
      type: Object,
      required: true,
    },
    linkTo: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  computed: {
    isLink(): boolean {
      return !isEmpty(this.linkTo);
    },
  },

  methods: {
    onCardClick(event: MouseEvent) {
      this.$emit('card-click', event);
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
.card {
  position: relative;
}

.card__wrap {
  transition: all 0.2s ease-in-out;
  border-radius: settings.$border-radius;
}

.card__link {
  position: relative;
  display: flex;
  outline: none;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  height: 240px;
  padding: 16px 16px 22px;
  background: colors.$color-white;
  border: 1px solid colors.$color-grey-200;
  border-radius: settings.$border-radius;
  transition: all 0.2s ease-in-out;
}

.card__link::before {
  content: '';
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 6px;
  background: var(--card-color);
}

.card--link:hover,
.card--link:focus-within {
  .card__wrap {
    box-shadow: settings.$box-shadow-card-layer-1, settings.$box-shadow-card-layer-2;
    transform: translateY(-8px);
  }
}

.card__top {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card__bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.card__actions {
  display: flex;
  margin-left: auto;
  gap: 4px;
}

.card__settings {
  position: absolute;
  bottom: 24px;
  right: 24px;
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.card:hover,
.card:focus-within {
  .card__settings {
    opacity: 1;
    pointer-events: all;
  }
}
</style>
